import React from 'react'

const Testimonials = () => {
  return (
    <>
        <section className='section position-relative clients_say'>
                <div className="container">
                    <div className="col-12">
                        <span className='span_head'>Our Clients Have To Say About Us</span>
                        <h3 className='heading mt-3'>We Grow When Our Clients Grow</h3>
                        <div className="heading-divider mb-4"></div>
                    </div>
                    <div className="row mt-5">

                        <div className="col-lg-3 col-md-4">
                            <div className="card border-0 mb-4">
                                <div className="card-body">
                                    <div className="keywords">
                                        Masters
                                    </div>
                                    <div className="stars">
                                        <i className="fa-solid fa-star"></i>
                                        <i className="fa-solid fa-star"></i>
                                        <i className="fa-solid fa-star"></i>
                                        <i className="fa-solid fa-star"></i>
                                    </div>
                                    <p>When it comes to the technical aspect of website development, Websitedrona truly excels. They are <span>masters</span> of their craft, utilizing the...</p>
                                </div>
                                <div className="client-name mt-3 d-flex align-items-center">
                                    <div className="name-icon">
                                        <div>C</div>
                                    </div>
                                    <div className="name-wrape ms-3">
                                        <h5 className='m-0'>Courier Mitra</h5>
                                        <p className='m-0'>Courier Mitra , CEO</p>
                                    </div>
                                </div>
                            </div>
                            <div className="card border-0">
                                <div className="card-body">
                                    <div className="keywords">
                                        best
                                    </div>
                                    <div className="stars">
                                        <i className="fa-solid fa-star"></i>
                                        <i className="fa-solid fa-star"></i>
                                        <i className="fa-solid fa-star"></i>
                                        <i className="fa-solid fa-star"></i>
                                    </div>
                                    <p>Website Drona,  the <span>best</span> Website Designing Company in Delhi.</p>
                                </div>
                                <div className="client-name mt-3 d-flex align-items-center">
                                    <div className="name-icon">
                                        <div>C</div>
                                    </div>
                                    <div className="name-wrape ms-3">
                                        <h5 className='m-0'>Lalita Sisodiya</h5>
                                        <p className='m-0'>Client</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-4">
                            <div className="card border-0 mb-4">
                                <div className="card-body">
                                    <div className="keywords">
                                        professionals
                                    </div>
                                    <div className="stars">
                                        <i className="fa-solid fa-star"></i>
                                        <i className="fa-solid fa-star"></i>
                                        <i className="fa-solid fa-star"></i>
                                        <i className="fa-solid fa-star"></i>
                                    </div>
                                    <p>I highly recommend Websitedrona for anyone in need of website design and development services. They are a team of dedicated <span>professionals</span> who are passionate about what they do,...</p>
                                </div>
                                <div className="client-name mt-3 d-flex align-items-center">
                                    <div className="name-icon">
                                        <img src="./images/azula.png" width='45' alt="" />
                                    </div>
                                    <div className="name-wrape ms-3">
                                        <h5 className='m-0'>Azula Hospitality</h5>
                                        <p className='m-0'>Azula Hospitality , Founder</p>
                                    </div>
                                </div>
                            </div>
                            <div className="card border-0">
                                <div className="card-body">
                                    <div className="keywords">
                                        Masters
                                    </div>
                                    <div className="stars">
                                        <i className="fa-solid fa-star"></i>
                                        <i className="fa-solid fa-star"></i>
                                        <i className="fa-solid fa-star"></i>
                                        <i className="fa-solid fa-star"></i>
                                    </div>
                                    <p>When it comes to the technical aspect of website development, Websitedrona truly excels. They are <span>masters</span> of their craft, utilizing the...</p>
                                </div>
                                <div className="client-name mt-3 d-flex align-items-center">
                                    <div className="name-icon">
                                        <div>C</div>
                                    </div>
                                    <div className="name-wrape ms-3">
                                        <h5 className='m-0'>Courier Mitra</h5>
                                        <p className='m-0'>Courier Mitra , CEO</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-4">
                            <div className="card border-0 mb-4">
                                <div className="card-body">
                                    <div className="keywords">
                                        Great design
                                    </div>
                                    <div className="stars">
                                        <i className="fa-solid fa-star"></i>
                                        <i className="fa-solid fa-star"></i>
                                        <i className="fa-solid fa-star"></i>
                                        <i className="fa-solid fa-star"></i>
                                    </div>
                                    <p><span>Great design</span> team and quick turn around on all projects and request. With their help we have improved our google search results.</p>
                                </div>
                                <div className="client-name mt-3 d-flex align-items-center">
                                    <div className="name-icon">
                                        <div>J</div>
                                    </div>
                                    <div className="name-wrape ms-3">
                                        <h5 className='m-0'>Jagdish kumar</h5>
                                        <p className='m-0'>Client</p>
                                    </div>
                                </div>
                            </div>
                            <div className="card border-0">
                                <div className="card-body">
                                    <div className="keywords">
                                        Excellent service
                                    </div>
                                    <div className="stars">
                                        <i className="fa-solid fa-star"></i>
                                        <i className="fa-solid fa-star"></i>
                                        <i className="fa-solid fa-star"></i>
                                        <i className="fa-solid fa-star"></i>
                                    </div>
                                    <p><span>Excellent service</span></p>
                                </div>
                                <div className="client-name mt-3 d-flex align-items-center">
                                    <div className="name-icon">
                                    <div>A</div>
                                    </div>
                                    <div className="name-wrape ms-3">
                                        <h5 className='m-0'>Asjad Hussain</h5>
                                        <p className='m-0'>Client</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4">
                            <div className="card border-0">
                                <div className="card-body">
                                    <div className="keywords">
                                      Good service
                                    </div>
                                    <div className="stars">
                                        <i className="fa-solid fa-star"></i>
                                        <i className="fa-solid fa-star"></i>
                                        <i className="fa-solid fa-star"></i>
                                        <i className="fa-solid fa-star"></i>
                                    </div>
                                    <p><span>Good service</span> provider they did my website accordingly to my needs and that too within my budget, excellent team and prompt response.</p>
                                </div>
                                <div className="client-name mt-3 d-flex align-items-center">
                                    <div className="name-icon">
                                        <div>A</div>
                                    </div>
                                    <div className="name-wrape ms-3">
                                        <h5 className='m-0'>ARMRBOX LOGISTICS</h5>
                                        <p className='m-0'>Client</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="lines">
                    <div className="line"></div>
                    <div className="line"></div>
                    <div className="line"></div>
                    <div className="line"></div>
                    <div className="line"></div>
                </div> */}
            </section>
    </>
  )
}

export default Testimonials